import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import Footer from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState<{ title: string; content: string } | null>(null);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      const { data, error } = await supabase
        .from('terms_policies')
        .select('title, content')
        .eq('category', 'privacy')
        .single();

      if (error) {
        console.error('Error fetching privacy policy:', error);
        return;
      }

      if (data) {
        setPolicy(data);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="container mx-auto px-4 py-8 flex-grow">
        <Card className="w-full max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-center">
              {policy?.title || "Privacy Policy"}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ScrollArea className="h-[60vh]">
              <div className="prose prose-sm max-w-none">
                {policy?.content ? (
                  <div dangerouslySetInnerHTML={{ __html: policy.content.replace(/\n/g, '<br/>') }} />
                ) : (
                  <p className="text-center text-gray-500">Loading privacy policy...</p>
                )}
              </div>
            </ScrollArea>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
